import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import Navbar from "./LandingPage/Navbar";
import Footer from "./LandingPage/Footer";
import PricingPlans from "../components/pricing/PricingPlans";
import { usePlanCatalog } from "../hooks/usePlanCatalog";
import { Plan } from "../config/plans";

const Pricing = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth0();
  const { catalog } = usePlanCatalog();

  // A signed-in visitor must not be bounced to /login — that redirects straight
  // back to /accounts and the upgrade silently does nothing. Send them to the
  // billing section with the plan preselected instead.
  const handleSelect = (plan: Plan) => {
    if (plan.ctaKind === "contact") return navigate("/contact");
    if (isAuthenticated) return navigate(`/settings?plan=${plan.id}#billing`);
    navigate("/login");
  };

  return (
    // `landing-theme` is required here: this page renders the LandingPage Navbar
    // and Footer, which are designed against that theme's dark palette. Without
    // it they sat on a light background and looked broken.
    <div className="min-h-screen bg-background landing-theme">
      <Navbar />

      <section className="pt-32 pb-24">
        <div className="container mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h1 className="text-5xl md:text-6xl font-heading font-bold mb-6 bg-gradient-to-r from-primary to-blue-400 bg-clip-text text-transparent">
              Simple, Transparent Pricing
            </h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Choose the plan that fits your community. Start free, upgrade when
              you need more.
            </p>
          </motion.div>

          <PricingPlans plans={catalog.plans} onSelect={handleSelect} variant="page" />
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Pricing;
